export const SORT_DIRECTIONS = {
  ASCENDING: '1',
  DESCENDING: '-1',
};

export const SORT_OPTIONS = {
  NEWEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Newest first',
  },
  OLDEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Oldest first',
  },
  EMAIL_ASCENDING: {
    value: 'customerEmail',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Email A-Z',
  },
  EMAIL_DESCENDING: {
    value: 'customerEmail',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Email Z-A',
  },
};

export const FILTER_OPTIONS = {
  ALL: {
    value: 'all',
    label: 'All',
  },
  PAID: {
    value: 'paid',
    label: 'Paid',
  },
  PARTIALLY_PAID: {
    value: 'partially_paid',
    label: 'Partially paid',
  },
  RECOVERED: {
    value: 'recovered',
    label: 'Recovered',
  },
  UNPAID: {
    value: 'unpaid',
    label: 'Unpaid',
  },
  INCOMPLETE: {
    value: 'incomplete',
    label: 'Incomplete',
  },
  FAILED: {
    value: 'failed',
    label: 'Failed',
  },
  REFUNDED: {
    value: 'refunded',
    label: 'Refunded',
  },
  PARTIAL_REFUND: {
    value: 'partial_refund',
    label: 'Partial refund',
  },
  CANCELED: {
    value: 'canceled',
    label: 'Canceled',
  },
  ABANDONED: {
    value: 'abandoned',
    label: 'Abandoned',
  },
};

export const COUPON_FILTER_OPTIONS = {
  ALL: {
    value: 'all',
    label: 'All',
  },
  PAID: {
    value: 'paid',
    label: 'Paid',
  },
  PARTIALLY_PAID: {
    value: 'partially_paid',
    label: 'Partially paid',
  },
  RECOVERED: {
    value: 'recovered',
    label: 'Recovered',
  },
  UNPAID: {
    value: 'unpaid',
    label: 'Unpaid',
  },
  REFUNDED: {
    value: 'refunded',
    label: 'Refunded',
  },
  PARTIAL_REFUND: {
    value: 'partial_refund',
    label: 'Partial refund',
  },
  CANCELED: {
    value: 'canceled',
    label: 'Canceled',
  },
};

export function getSortOptionFromQuery(sortBy, sortDirection) {
  const sortOption = Object.keys(SORT_OPTIONS).find(
    key => SORT_OPTIONS[key].value === sortBy && SORT_OPTIONS[key].direction === sortDirection,
  );

  return sortOption || Object.keys(SORT_OPTIONS)[0];
}

export function getStatusFromQuery(status) {
  const statusOption = Object.keys(FILTER_OPTIONS).find(
    key => FILTER_OPTIONS[key].value === status,
  );

  return statusOption || Object.keys(FILTER_OPTIONS)[0];
}
